const EBS_FLAG_KEY = "isRedirectFromEBS";

const isBrowser = typeof window !== "undefined";

export function isRedirectFromEbsSession(): boolean {
    return isBrowser && sessionStorage.getItem(EBS_FLAG_KEY) === "true";
}

export function setRedirectFromEbsSession(value: boolean): void {
    if (isBrowser) {
        sessionStorage.setItem(EBS_FLAG_KEY, value ? "true" : "false");
    }
}

export function clearRedirectFromEbsSession(): void {
    if (isBrowser) {
        sessionStorage.removeItem(EBS_FLAG_KEY);
    }
}

export interface UpgradeCheckInput {
    pageType?: string;
    billToCustomerNumber?: string | null;
    redirectedFromEbs?: boolean;
}

export function shouldShowUpgradeToBusinessAccount({
    pageType,
    billToCustomerNumber,
    redirectedFromEbs,
}: UpgradeCheckInput = {}): boolean {
    const isFromEbs = redirectedFromEbs ?? (isBrowser ? isRedirectFromEbsSession() : false);

    return (
        pageType === "SubscriptionsDashboardPage" &&
        !!billToCustomerNumber &&
        billToCustomerNumber.startsWith("WEB") &&
        !isFromEbs
    );
}
